export default __webpack_public_path__ + "static/media/interreg.536436f4.jpg";